import { SERVICE } from '@src/constants';
import api from './api';

export const getCategories = async (params) => {
  const res = await api({
    method: 'GET',
    url: '/categories',
    params,
    source: SERVICE.API_MANAGEMENT,
  });
  return res;
};
